<template>
  <div>
    <b-row>
      <b-col md="9"><h3>Order Report</h3></b-col>
      <b-col md="3">
        <div class="text-right">
          <b-button
            variant="primary"
            @click="
              $router.push({ name: 'history', params: { type: 'ORDER' } })
            "
            >View Download History</b-button
          >
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="8" class="pt-0 pb-0">
        <h4>Order Dashboard</h4>
      </b-col>
      <b-col md="1" class="text-right pt-0 pb-0">
        <!-- <a href="#">
        <img
          src="@/assets/images/DataExport.png"
          class="upload-btn"
          alt="data export"  
        /></a> -->
      </b-col>
      <b-col md="3" class="pt-0 pb-0">
        <eb-select
          style="background-color: #fff"
          id="text"
          type="text"
          label="text"
          :options="dateOption2"
          v-model="selectedDate2"
          :selected="selectedDate2.text"
          @input="changeDate2"
        >
        </eb-select>
        <b-modal
          title="Select Date"
          header-class="header-nipige-class"
          id="dateRange2"
          size="sm"
          ref="date-range2"
          centered
          hide-footer
        >
          <b-input class="mb-2" type="date" v-model="startDate2"></b-input>
          <b-input type="date" v-model="endDate2"></b-input>
          <div class="text-center mt-2">
            <b-button
              @click="findButtonClick2()"
              class="my -0 main-navigation-button w-47 mr-2"
              variant="success"
            >
              Find
            </b-button>
          </div>
        </b-modal>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <b-card-group deck>
          <b-card class="total-order-header">
            <template #header>
              <div class="d-flex justify-content-between">
                <h4 class="text-white">Total Order</h4>
                <h3 class="text-white text-right">
                  {{ totalOrder }}/{{ orderCount }}
                </h3>
              </div>
            </template>
            <b-card-text>
              <div class="row">
                <h4 class="col-md-4 pt-0 pb-0">Pay on Delivery</h4>
                <h4 class="col-md-4 pt-0 pb-0">रु {{ deliveryOrder }}</h4>
                <h4 class="col-md-4 pt-0 pb-0">{{ deliveryCount }}</h4>
              </div>
              <div class="row">
                <h4 class="col-md-4 pt-0 pb-0">Pre Paid</h4>
                <h4 class="col-md-4 pt-0 pb-0">रु {{ prePaidOrder }}</h4>
                <h4 class="col-md-4 pt-0 pb-0">{{ prePaidOrderCount }}</h4>
              </div>
              <div class="row">
                <h4 class="col-md-4 pt-0 pb-0">Product</h4>
                <h4 class="col-md-4 pt-0 pb-0">रु {{ productOrder }}</h4>
                <h4 class="col-md-4 pt-0 pb-0">{{ productOrderCount }}</h4>
              </div>
              <div class="row">
                <h4 class="col-md-4 pt-0 pb-0">Service</h4>
                <h4 class="col-md-4 pt-0 pb-0">रु {{ serviceOrders }}</h4>
                <h4 class="col-md-4 pt-0 pb-0">{{ serviceCount }}</h4>
              </div>
            </b-card-text>
          </b-card>
        </b-card-group>
      </b-col>
      <b-col md="6">
        <b-card-group deck>
          <b-card class="orderbyStatus-header">
            <template #header>
              <div class="d-flex justify-content-between">
                <h4 class="text-white">Order by Status</h4>
              </div>
            </template>
            <b-card-text>
              <div class="row">
                <h4 class="col-md-4 pt-0 pb-0">Completed</h4>
                <h4 class="col-md-4 pt-0 pb-0">रु {{ completedOrders }}</h4>
                <h4 class="col-md-4 pt-0 pb-0">{{ completedCount }}</h4>
              </div>
              <div class="row">
                <h4 class="col-md-4 pt-0 pb-0">Pending</h4>
                <h4 class="col-md-4 pt-0 pb-0">रु {{ pendingOrders }}</h4>
                <h4 class="col-md-4 pt-0 pb-0">{{ pendingOrdersCount }}</h4>
              </div>
              <div class="row">
                <h4 class="col-md-4 pt-0 pb-0">Processing</h4>
                <h4 class="col-md-4 pt-0 pb-0">रु {{ ongoingOrders }}</h4>
                <h4 class="col-md-4 pt-0 pb-0">{{ ongoingOrdersCount }}</h4>
              </div>
              <div class="row">
                <h4 class="col-md-4 pt-0 pb-0">Cancelled</h4>
                <h4 class="col-md-4 pt-0 pb-0">रु {{ cancelledOrders }}</h4>
                <h4 class="col-md-4 pt-0 pb-0">{{ cancelledOrderCount }}</h4>
              </div>
              <!-- <div class="row">
                <h4 class="col-md-4 pt-0 pb-0">Returned</h4>
                <h4 class="col-md-4 pt-0 pb-0">रु 50000000</h4>
                <h4 class="col-md-4 pt-0 pb-0">10980</h4>
              </div> -->
            </b-card-text>
          </b-card>
        </b-card-group>
      </b-col>
      <b-col md="6">
        <b-card-group deck>
          <b-card class="orderbySale-header">
            <template #header>
              <div class="d-flex justify-content-between">
                <h4 class="text-white">Order by Sales Channel</h4>
              </div>
            </template>
            <b-card-text>
              <div class="row">
                <h4 class="col-md-4 pt-0 pb-0">POS</h4>
                <h4 class="col-md-4 pt-0 pb-0">रु {{ posOrder }}</h4>
                <h4 class="col-md-4 pt-0 pb-0">{{ posOrderCount }}</h4>
              </div>
              <div class="row">
                <h4 class="col-md-4 pt-0 pb-0">Online</h4>
                <h4 class="col-md-4 pt-0 pb-0">रु {{ onlineOrder }}</h4>
                <h4 class="col-md-4 pt-0 pb-0">{{ onlineOrderCount }}</h4>
              </div>
              <!-- <div class="row">
                <h4 class="col-md-4 pt-0 pb-0">In Store</h4>
                <h4 class="col-md-4 pt-0 pb-0">रु 50000000</h4>
                <h4 class="col-md-4 pt-0 pb-0">10980</h4>
              </div> -->
            </b-card-text>
          </b-card>
        </b-card-group>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col md="5">
        <b-row>
          <b-col md="2" class="text-right">
            <a href="#">
              <img
                src="@/assets/images/DataExport.png"
                class="upload-btn"
                alt="data export"
                @click="createRequest"
              />
            </a>
          </b-col>
          <b-col md="5">
            <eb-select
              style="background-color: #fff"
              id="text"
              type="text"
              label="text"
              :options="dateOption"
              v-model="selectedDate"
              :selected="selectedDate.text"
              @input="changeDate"
            >
            </eb-select>
            <b-modal
              title="Select Date"
              header-class="header-nipige-class"
              id="dateRange"
              size="sm"
              ref="date-range"
              centered
              hide-footer
            >
              <b-input class="mb-2" type="date" v-model="startDate"></b-input>
              <b-input type="date" v-model="endDate"></b-input>
              <div class="text-center mt-2">
                <b-button
                  @click="findButtonClick()"
                  class="my -0 main-navigation-button w-47 mr-2"
                  variant="success"
                >
                  Find
                </b-button>
              </div>
            </b-modal>
          </b-col>
          <b-col md="5">
            <ev-select
              style="background-color: #fff"
              id="text"
              type="text"
              label="text"
              placeholder="Select Status"
              :options="statusOptions"
              v-model="selectedStatusOptions"
              :selected="selectedStatusOptions.text"
              @input="changeStatus"
            >
            </ev-select>
          </b-col>
        </b-row>
        <b-row class="mt-0">
          <b-col md="12" class="pt-0">
            <b-card style="height: 100%">
              <h4>Order by Status</h4>
              <div
                v-if="
                  getChartData &&
                  getChartData.labels &&
                  getChartData.labels.length > 0
                "
              >
                <Doughnut
                  class="doughnut chart-doughnut"
                  :chart-data="getChartData"
                  :chart-options="chartOptions"
                ></Doughnut>
              </div>
              <div v-else>
                <h4 class="text-center my-5">No Data Available</h4>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="7">
        <b-row>
          <b-col md="2"></b-col>
          <b-col md="2" class="text-right">
            <!-- <a href="#">
            <img
              src="@/assets/images/DataExport.png"
              class="upload-btn"
              alt="data export"
            /></a> -->
          </b-col>
          <b-col md="4">
            <eb-select
              style="background-color: #fff"
              id="text"
              type="text"
              label="text"
              :options="dateOption1"
              v-model="selectedDate1"
              :selected="selectedDate1.text"
              @input="changeDate1"
            >
            </eb-select>
            <b-modal
              title="Select Date"
              header-class="header-nipige-class"
              id="dateRange1"
              size="sm"
              ref="date-range1"
              centered
              hide-footer
            >
              <b-input class="mb-2" type="date" v-model="startDate1"></b-input>
              <b-input type="date" v-model="endDate1"></b-input>
              <div class="text-center mt-2">
                <b-button
                  @click="findButtonClick1()"
                  class="my -0 main-navigation-button w-47 mr-2"
                  variant="success"
                  >Find
                </b-button>
              </div>
            </b-modal>
          </b-col>
          <b-col md="4">
            <ev-select
              style="background-color: #fff"
              id="text"
              type="text"
              label="text"
              placeholder="Select Status"
              :options="statusOptions1"
              v-model="selectedStatusOptions1"
              :selected="selectedStatusOptions1.text"
              @input="changeStatus1"
            >
            </ev-select>
          </b-col>
        </b-row>
        <b-row class="mt-0">
          <b-col md="12" class="pt-0">
            <b-card style="height: 100%">
              <h4>Order Value vs Order</h4>
              <div
                v-if="
                  chartData && chartData.labels && chartData.labels.length > 0
                "
              >
                <BarChart
                  :chart-data="chartData"
                  :chart-options="barChartOptions1"
                  class="h-100 mt-5"
                />
              </div>
              <div v-else>
                <h4 class="text-center my-5">No Data Available</h4>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- <b-row>
      <b-col md="5">
        <b-row>
          <b-col md="2" class="text-right">
            <a href="#">
            <img
              src="@/assets/images/DataExport.png"
              class="upload-btn"
              alt="data export"
            />
            </a>
          </b-col>
          <b-col md="5">
            <eb-select
              style="background-color: #fff"
              id="text"
              type="text"
              label="text"
              :options="dateOption"
              v-model="selectedDate"
              :selected="selectedDate.text"
              @input="changeDate"
            >
            </eb-select>
            <b-modal
              title="Select Date"
              header-class="header-nipige-class"
              id="dateRange"
              size="sm"
              ref="date-range"
              centered
              hide-footer
            >
              <b-input class="mb-2" type="date" v-model="startDate"></b-input>
              <b-input type="date" v-model="endDate"></b-input>
              <div class="text-center mt-2">
                <b-button
                  @click="findButtonClick()"
                  class="my -0 main-navigation-button w-47 mr-2"
                  variant="success"
                >
                  Find
                </b-button>
              </div>
            </b-modal>
          </b-col>
          <b-col md="5">
            <ev-select
              style="background-color: #fff"
              id="text"
              type="text"
              label="text"
              placeholder="Select Status"
              :options="statusOptions"
              v-model="selectedStatusOptions"
              :selected="selectedStatusOptions.text"
              @input="changeStatus"
            >
            </ev-select>
          </b-col>
        </b-row>
        <b-row class="mt-0">
            <b-col md="12" class="pt-0">
              <b-card style="height:100%">
                <h4>Order by Market</h4>
                  <div
                    v-if="
                      getChartData &&
                      getChartData.labels &&
                      getChartData.labels.length > 0
                    "
                  >
                    <Doughnut
                      class="doughnut chart-doughnut"
                      :chart-data="getChartData"
                      :chart-options="chartOptions"
                    ></Doughnut>
                  </div>
                  <div v-else>
                    <h4 class="text-center my-5">No Data Available</h4>
                  </div>
              </b-card>
            </b-col>
          </b-row>
      </b-col>
      <b-col md="7">
        <b-row>
          <b-col md="2"></b-col>
          <b-col md="2" class="text-right">
            <a href="#">
            <img
              src="@/assets/images/DataExport.png"
              class="upload-btn"
              alt="data export"
            /></a>
          </b-col>
          <b-col md="4">
            <eb-select
              style="background-color: #fff"
              id="text"
              type="text"
              label="text"
              :options="dateOption1"
              v-model="selectedDate1"
              :selected="selectedDate1.text"
              @input="changeDate1"
            >
            </eb-select>
            <b-modal
              title="Select Date"
              header-class="header-nipige-class"
              id="dateRange1"
              size="sm"
              ref="date-range1"
              centered
              hide-footer
            >
              <b-input
                class="mb-2"
                type="date"
                v-model="startDate1"
              ></b-input>
              <b-input type="date" v-model="endDate1"></b-input>
              <div class="text-center mt-2">
                <b-button
                  @click="findButtonClick1()"
                  class="my -0 main-navigation-button w-47 mr-2"
                  variant="success"
                  >Find
                </b-button>
              </div>
            </b-modal>
          </b-col>
          <b-col md="4">
            <ev-select
              style="background-color: #fff"
              id="text"
              type="text"
              label="text"
              placeholder="Select Status"
              :options="statusOptions1"
              v-model="selectedStatusOptions1"
              :selected="selectedStatusOptions1.text"
              @input="changeStatus1"
            >
            </ev-select>
          </b-col>
        </b-row>
        <b-row class="mt-0">
          <b-col md="12" class="pt-0">
            <b-card style="height:100%">
              <h4>Top 10 Products</h4>
                <div
                  v-if="chartData && chartData.labels && chartData.labels.length > 0"
                >
                  <BarChart
                    :chart-data="chartData"
                    :chart-options="barChartOptions1"
                    class="h-100 mt-5"
                  />
                </div>
                <div v-else>
                  <h4 class="text-center my-5">No Data Available</h4>
                </div>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row> -->

    <b-row class="mt-3">
      <b-col md="8" class="pb-0"></b-col>
      <b-col md="1" class="text-right pb-0">
        <!-- <a href="#">
        <img
          src="@/assets/images/DataExport.png"
          class="upload-btn"
          alt="data export"
        /></a> -->
      </b-col>
      <b-col md="3" class="pb-0">
        <eb-select
          style="background-color: #fff"
          id="text"
          type="text"
          label="text"
          :options="dateOption3"
          v-model="selectedDate3"
          :selected="selectedDate3.text"
          @input="changeDate3"
        >
        </eb-select>
        <b-modal
          title="Select Date"
          header-class="header-nipige-class"
          id="dateRange3"
          size="sm"
          ref="date-range3"
          centered
          hide-footer
        >
          <b-input class="mb-2" type="date" v-model="startDate3"></b-input>
          <b-input type="date" v-model="endDate3"></b-input>
          <div class="text-center mt-2">
            <b-button
              @click="findButtonClick3()"
              class="my -0 main-navigation-button w-47 mr-2"
              variant="success"
              >Find
            </b-button>
          </div>
        </b-modal>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12" class="pt-0">
        <b-card>
          <h4>Order by Type</h4>
          <div
            v-if="
              orderByTypeChartData &&
              orderByTypeChartData.labels &&
              orderByTypeChartData.labels.length > 0
            "
          >
            <BarChart
              :chart-data="orderByTypeChartData"
              :chart-options="barChartOptions"
            />
          </div>

          <div v-else>
            <h4 class="text-center my-5">No Data Available</h4>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ComponentHeader from "@/components/componentHeader";
import moment from "moment";
import BarChart from "@/components/chart/BarChart";
import ebSelect from "@/components/FormElements/Select.vue";
import evSelect from "@/components/FormElements/Multiselect.vue";
import Doughnut from "@/components/chart/Doughnut.js";
import doughChartDataGenerator from "@/utils/doughChartDataGenerator";
import orderListBarChartDataGenerator from "@/utils/orderListBarChartDataGenerator";
import generateOrderByTypeChartData from "@/utils/generateOrderByTypeChartData";
export default {
  name: "Reports",
  components: {
    BarChart,
    ComponentHeader,
    Doughnut,
    ebSelect,
    evSelect,
  },
  data() {
    return {
      onlineOrder: 0,
      onlineOrderCount: 0,
      posOrder: 0,
      posOrderCount: 0,
      quoteRequest: 0,
      quoteRequestCount: 0,
      ongoingOrders: 0,
      ongoingOrdersCount: 0,
      pendingOrders: 0,
      pendingOrdersCount: 0,
      cancelledOrders: 0,
      cancelledOrderCount: 0,
      completedCount: 0,
      completedOrders: 0,
      serviceCount: 0,
      serviceOrders: 0,
      productOrder: 0,
      productOrderCount: 0,
      prePaidOrder: 0,
      prePaidOrderCount: 0,
      deliveryCount: 0,
      deliveryOrder: 0,
      totalCustomer: 0,
      repeatedCustomer: 0,
      totalOrder: 0,
      orderCount: 0,

      chartOptions: {
        hoverBorderWidth: 10,
      },

      selectedDate: {
        text: "Today",
        value: 1,
      },
      dateOption: [
        {
          text: "Today",
          value: 1,
        },
        {
          text: "7 day's",
          value: 7,
        },
        {
          text: "30 day's",
          value: 30,
        },
        {
          text: "Custom",
          value: "custom",
        },
      ],
      startDate: "",
      endDate: "",

      selectedDate1: {
        text: "Today",
        value: 1,
      },
      dateOption1: [
        {
          text: "Today",
          value: 1,
        },
        {
          text: "7 day's",
          value: 7,
        },
        {
          text: "30 day's",
          value: 30,
        },
        {
          text: "Custom",
          value: "custom",
        },
      ],
      startDate1: "",
      endDate1: "",

      selectedDate2: {
        text: "Today",
        value: 1,
      },
      dateOption2: [
        {
          text: "Today",
          value: 1,
        },
        {
          text: "7 day's",
          value: 7,
        },
        {
          text: "30 day's",
          value: 30,
        },
        {
          text: "Custom",
          value: "custom",
        },
      ],
      startDate2: "",
      endDate2: "",

      selectedDate3: {
        text: "Today",
        value: 1,
      },
      dateOption3: [
        {
          text: "Today",
          value: 1,
        },
        {
          text: "7 day's",
          value: 7,
        },
        {
          text: "30 day's",
          value: 30,
        },
        {
          text: "Custom",
          value: "custom",
        },
      ],
      startDate3: "",
      endDate3: "",
      barChartOptions1: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          y: {
            display: true,
            position: "left",
            title: {
              display: true,
              text: "Order Value",
              font: {
                size: 15,
              },
              color: "#002872",
            },
          },
          y1: {
            display: true,
            position: "right",
            title: {
              display: true,
              text: "Order Count",
              font: {
                size: 15,
              },
              color: "#6EBAFF",
            },
            grid: {
              drawOnChartArea: false,
            },
          },
        },
        plugins: {
          title: {
            position: "bottom",
            display: true,
            text: "Date",
            font: {
              size: 15,
            },
            color: "#",
          },
        },
      },
      barChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          // tooltip: {
          //   callbacks: {
          //     footer: (context) => {
          //       console.log(context);
          //       console.log(context[0].dataIndex, "Index");
          //       console.log(context[0].dataset.data.length, "IndexLength");
          //       console.log(this.datasets[0], "nextDataset");
          //       // if (context[0].dataIndex < context[0].dataset.data.length) {
          //         const orderCount = datasets[(context[0].datasetIndex) + 1].data[dataindex];
          //         console.log(orderCount, "count")
          //         return `Order Count: ${orderCount}`
          //       // }
          //     }
          //   }
          // }
        },
        scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: true,
          },
        },
      },
      selectedStatusOptions: [
        {
          text: "Created",
          value: "Created",
        },
      ],
      statusOptions: [
        {
          text: "Processing",
          value: "Processing",
        },
        {
          text: "Delivered",
          value: "Delivered",
        },
        {
          text: "Created",
          value: "Created",
        },
        {
          text: "Out For Delivery",
          value: "Out For Delivery",
        },
        {
          text: "Payment Failed",
          value: "Payment Failed",
        },
        {
          text: "Cancelled",
          value: "Cancelled",
        },
        {
          text: "Rejected",
          value: "Rejected",
        },
        {
          text: "Returned",
          value: "Returned",
        },
        {
          text: "Dispatched",
          value: "Dispatched",
        },
        {
          text: "Refund",
          value: "Refund",
        },
        {
          text: "Delivery Attached",
          value: "Delivery Attached",
        },
        {
          text: "Confirmed",
          value: "Confirmed",
        },
      ],
      selectedStatusOptions1: [
        {
          text: "Created",
          value: "Created",
        },
      ],
      statusOptions1: [
        {
          text: "Processing",
          value: "Processing",
        },
        {
          text: "Delivered",
          value: "Delivered",
        },
        {
          text: "Created",
          value: "Created",
        },
        {
          text: "Out For Delivery",
          value: "Out For Delivery",
        },
        {
          text: "Payment Failed",
          value: "Payment Failed",
        },
        {
          text: "Cancelled",
          value: "Cancelled",
        },
        {
          text: "Rejected",
          value: "Rejected",
        },
        {
          text: "Returned",
          value: "Returned",
        },
        {
          text: "Dispatched",
          value: "Dispatched",
        },
        {
          text: "Refund",
          value: "Refund",
        },
        {
          text: "Delivery Attached",
          value: "Delivery Attached",
        },
        {
          text: "Confirmed",
          value: "Confirmed",
        },
      ],
    };
  },
  computed: {
    userId() {
      if (this.$store.getters["auth/getUserID"]) {
        return this.$store.getters["auth/getUserID"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
      }
    },
    getChartData() {
      let dataList = this.$store.getters["partner/getBulkAnalyticsReport"];
      let dataKey = undefined;
      switch (this.$currentUserData.category) {
        case "TA":
          dataKey = "orderbystatus-graph";
          break;
        case "SELLER":
          dataKey = "seller-orderbystatus-graph";
          break;
        default:
          dataKey = "subdealer-orderbystatus-graph";
          break;
      }
      return doughChartDataGenerator(dataList, dataKey);
    },
    chartData() {
      let data = this.$store.getters["partner/getChartData"];
      let orderKey = "";
      let orderAmount = "";
      let orderCount = "";
      if (this.$currentUserData.category == "TA") {
        orderKey = "orderbyvalue-graph";
        orderAmount = "orderamount";
        orderCount = "ordercount";
      } else if (this.$currentUserData.category === "SELLER") {
        orderKey = "seller-orderbyvalue-graph";
        orderAmount = "orderamount";
        orderCount = "ordercount";
      } else if (
        this.$currentUserData.category === "DISTRIBUTOR" ||
        this.$currentUserData.category === "DEALER" ||
        this.$currentUserData.category === "SUB_DEALER"
      ) {
        orderKey = "subdealer-orderbyvalue-graph";
        orderAmount = "orderamount";
        orderCount = "ordercount";
      }
      const orderList = data[orderKey];
      return orderListBarChartDataGenerator(orderList, orderAmount, orderCount);
    },

    orderByTypeChartData() {
      let data = this.$store.getters["partner/GetOrderByTypeReport"];
      let posOrderKey = "";
      let posOrderAmount = "";
      let posOrderCount = "";
      let posDate = "";
      let posType = "";
      let onlineOrderKey = "";
      let onlineOrderAmount = "";
      let onlineOrderCount = "";
      let onlineDate = "";
      let onlineType = "";
      if (this.$currentUserData.category == "TA") {
        posOrderKey = "orderbytype-pos-graph";
        posOrderAmount = "orderamount";
        posOrderCount = "ordercount";
        posDate = "date";
        posType = "type";
        onlineOrderKey = "orderbytype-online-graph";
        onlineOrderAmount = "orderamount";
        onlineOrderCount = "ordercount";
        onlineDate = "date";
        onlineType = "type";
      } else if (this.$currentUserData.category === "SELLER") {
        posOrderKey = "seller-orderbytype-pos-graph";
        posOrderAmount = "orderamount";
        posOrderCount = "ordercount";
        posDate = "date";
        posType = "type";
        onlineOrderKey = "seller-orderbytype-online-graph";
        onlineOrderAmount = "orderamount";
        onlineOrderCount = "ordercount";
        onlineDate = "date";
        onlineType = "type";
      } else if (
        this.$currentUserData.category === "DISTRIBUTOR" ||
        this.$currentUserData.category === "DEALER" ||
        this.$currentUserData.category === "SUB_DEALER"
      ) {
        posOrderKey = "subdealer-orderbytype-pos-graph";
        posOrderAmount = "orderamount";
        posOrderCount = "ordercount";
        posDate = "date";
        posType = "type";
        onlineOrderKey = "subdealer-orderbytype-online-graph";
        onlineOrderAmount = "orderamount";
        onlineOrderCount = "ordercount";
        onlineDate = "date";
        onlineType = "type";
      }
      const posOrderList = data[posOrderKey];
      const onlineOrderList = data[onlineOrderKey];
      return generateOrderByTypeChartData(
        posOrderList,
        posOrderAmount,
        posOrderCount,
        posDate,
        posType,
        onlineOrderList,
        onlineOrderAmount,
        onlineOrderCount,
        onlineDate,
        onlineType
      );
    },
  },

  methods: {
    findButtonClick2() {
      let e = {
        fromDate: this.startDate2,
        toDate: this.endDate2,
      };
      this.$refs["date-range2"].hide();
      this.dashboardReport();
    },
    changeDate2(e) {
      this.selectedDate2 = e;
      if (e.value == "custom") {
        this.$refs["date-range2"].show();
        return;
      }
      this.dashboardReport();
    },
    getDateData2(dateData) {
      if (dateData == "custom") {
        const data = {
          fromDate: this.startDate2,
          toDate: this.endDate2,
        };
        return data;
      }
      if (dateData == 1) {
        const data = {
          fromDate: moment().format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        };
        return data;
      } else {
        const data = {
          fromDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        };
        if (typeof dateData === "number") {
          data.fromDate = moment()
            .subtract(dateData, "days")
            .format("YYYY-MM-DD");
          return data;
        } else if (typeof dateData === "object") {
          return dateData;
        }
        return data;
      }
    },
    async dashboardReport() {
      if (this.$currentUserData.category === "TA") {
        const payload = {
          items: [
            {
              key: "total-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                tenant: this.userId,
              },
            },
            {
              key: "prepaid-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                tenant: this.userId,
              },
            },
            {
              key: "total-customers",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                tenant: this.userId,
              },
            },

            {
              key: "online-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                tenant: this.userId,
              },
            },
            {
              key: "cod-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                tenant: this.userId,
              },
            },
            {
              key: "product-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                tenant: this.userId,
              },
            },
            {
              key: "service-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                tenant: this.userId,
              },
            },
            {
              key: "pending-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                tenant: this.userId,
              },
            },
            {
              key: "completed-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                tenant: this.userId,
              },
            },
            {
              key: "ongoing-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                tenant: this.userId,
              },
            },
            {
              key: "cancelled-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                tenant: this.userId,
              },
            },
            {
              key: "pos-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                tenant: this.userId,
              },
            },
            {
              key: "repeated-customers",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                tenant: this.userId,
              },
            },
          ],
        };
        const data = await this.$store.dispatch(
          "partner/fetchBulkAnalyticReport",
          payload
        );
        this.onlineOrder = (
          +data["online-orders"]?.total_order_amount || 0
        ).toFixed(2);
        this.onlineOrderCount = data["online-orders"]?.total_order || 0;
        this.posOrder = (+data["pos-orders"]?.total_order_amount || 0).toFixed(
          2
        );
        this.posOrderCount = data["pos-orders"]?.total_order || 0;
        this.quoteRequest = 0;
        this.quoteRequestCount = 0;
        this.ongoingOrders = (
          +data["ongoing-orders"]?.total_order_amount || 0
        ).toFixed(2);
        this.ongoingOrdersCount = data["ongoing-orders"]?.total_order || 0;
        this.pendingOrders = (
          +data["pending-orders"]?.total_order_amount || 0
        ).toFixed(2);
        this.pendingOrdersCount = data["pending-orders"]?.total_order || 0;
        this.cancelledOrders = (
          +data["cancelled-orders"]?.total_order_amount || 0
        ).toFixed(2);
        this.cancelledOrderCount = data["cancelled-orders"]?.total_order || 0;
        this.completedCount = data["completed-orders"]?.total_order || 0;
        this.completedOrders = (
          +data["completed-orders"]?.total_order_amount || 0
        ).toFixed(2);
        this.serviceCount = data["service-orders"]?.total_order || 0;
        this.serviceOrders = (
          +data["service-orders"]?.total_order_amount || 0
        ).toFixed(2);
        this.productOrder = (
          +data["product-orders"]?.total_order_amount || 0
        ).toFixed(2);
        this.productOrderCount = data["product-orders"]?.total_order || 0;
        this.prePaidOrder = (
          +data["prepaid-orders"]?.total_order_amount || 0
        ).toFixed(2);
        this.prePaidOrderCount = data["prepaid-orders"]?.total_order || 0;
        this.deliveryCount = data["cod-orders"]?.total_order || 0;
        this.deliveryOrder = (
          +data["cod-orders"]?.total_order_amount || 0
        ).toFixed(2);
        this.totalCustomer = data["total-customers"]?.total_customer || 0;
        this.repeatedCustomer = data["repeated-customers"]?.count || 0;
        this.totalOrder = (
          +data["total-orders"]?.total_order_amount || 0
        ).toFixed(2);
        this.orderCount = data["total-orders"]?.total_order || 0;
      } else if (this.$currentUserData.category === "SELLER") {
        const payload = {
          items: [
            {
              key: "seller-total-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "seller-pos-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "seller-prepaid-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "seller-online-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "seller-cod-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "seller-product-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "seller-service-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "seller-pending-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "seller-completed-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "seller-ongoing-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "seller-cancelled-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
          ],
        };
        const data = await this.$store.dispatch(
          "partner/fetchBulkAnalyticReport",
          payload
        );
        this.onlineOrder = (
          +data["seller-online-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.onlineOrderCount = data["seller-online-orders"]?.total_order || 0;

        this.posOrder = (
          +data["seller-pos-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.posOrderCount = data["seller-pos-orders"]?.total_order || 0;

        this.quoteRequest = 0;

        this.quoteRequestCount = 0;

        this.ongoingOrders = (
          +data["seller-ongoing-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.ongoingOrdersCount =
          data["seller-ongoing-orders"]?.total_order || 0;

        this.pendingOrders = (
          +data["seller-pending-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.pendingOrdersCount =
          data["seller-pending-orders"]?.total_order || 0;

        this.cancelledOrders = (
          +data["seller-cancelled-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.cancelledOrderCount =
          data["seller-cancelled-orders"]?.total_order || 0;

        this.completedCount = data["seller-completed-orders"]?.total_order || 0;

        this.completedOrders = (
          +data["seller-completed-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.serviceCount = data["seller-service-orders"]?.total_order || 0;

        this.serviceOrders = (
          +data["seller-service-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.productOrder = (
          +data["seller-product-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.productOrderCount =
          data["seller-product-orders"]?.total_order || 0;

        this.prePaidOrder = (
          +data["seller-prepaid-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.prePaidOrderCount =
          data["seller-prepaid-orders"]?.total_order || 0;

        this.deliveryCount = data["seller-cod-orders"]?.total_order || 0;

        this.deliveryOrder = (
          +data["seller-cod-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.totalOrder = (
          +data["seller-total-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.orderCount = data["seller-total-orders"]?.total_order || 0;
      } else if (
        this.$currentUserData.category === "DISTRIBUTOR" ||
        this.$currentUserData.category === "DEALER" ||
        this.$currentUserData.category === "SUB_DEALER"
      ) {
        const payload = {
          items: [
            {
              key: "subdealer-total-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "subdealer-pos-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "subdealer-prepaid-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "subdealer-online-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "subdealer-cod-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "subdealer-product-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "subdealer-service-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "subdealer-pending-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "subdealer-completed-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "subdealer-ongoing-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "subdealer-cancelled-orders",
              variables: {
                ...this.getDateData2(this.selectedDate2.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
          ],
        };
        const data = await this.$store.dispatch(
          "partner/fetchBulkAnalyticReport",
          payload
        );
        this.onlineOrder = (
          +data["subdealer-online-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.onlineOrderCount =
          data["subdealer-online-orders"]?.total_order || 0;

        this.posOrder = (
          +data["subdealer-pos-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.posOrderCount = data["subdealer-pos-orders"]?.total_order || 0;

        this.quoteRequest = 0;

        this.quoteRequestCount = 0;

        this.ongoingOrders = (
          +data["subdealer-ongoing-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.ongoingOrdersCount =
          data["subdealer-ongoing-orders"]?.total_order || 0;

        this.pendingOrders = (
          +data["subdealer-pending-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.pendingOrdersCount =
          data["subdealer-pending-orders"]?.total_order || 0;

        this.cancelledOrders = (
          +data["subdealer-cancelled-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.cancelledOrderCount =
          data["subdealer-cancelled-orders"]?.total_order || 0;

        this.completedCount =
          data["subdealer-completed-orders"]?.total_order || 0;

        this.completedOrders = (
          +data["subdealer-completed-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.serviceCount = data["subdealer-service-orders"]?.total_order || 0;

        this.serviceOrders = (
          +data["subdealer-service-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.productOrder = (
          +data["subdealer-product-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.productOrderCount =
          data["subdealer-product-orders"]?.total_order || 0;

        this.prePaidOrder = (
          +data["subdealer-prepaid-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.prePaidOrderCount =
          data["subdealer-prepaid-orders"]?.total_order || 0;

        this.deliveryCount = data["subdealer-cod-orders"]?.total_order || 0;

        this.deliveryOrder = (
          +data["subdealer-cod-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.totalOrder = (
          +data["subdealer-total-orders"]?.total_order_amount || 0
        ).toFixed(2);

        this.orderCount = data["subdealer-total-orders"]?.total_order || 0;
      }
    },

    findButtonClick() {
      let e = {
        fromDate: this.startDate,
        toDate: this.endDate,
      };
      this.$refs["date-range"].hide();
      this.fetchOrderStatusChart();
    },
    changeDate(e) {
      this.selectedDate = e;
      if (e.value == "custom") {
        this.$refs["date-range"].show();
        return;
      }
      this.fetchOrderStatusChart();
    },
    getDateData(dateData) {
      if (dateData == "custom") {
        const data = {
          fromDate: this.startDate,
          toDate: this.endDate,
        };
        return data;
      }
      if (dateData == 1) {
        const data = {
          fromDate: moment().format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        };
        return data;
      } else {
        const data = {
          fromDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        };
        if (typeof dateData === "number") {
          data.fromDate = moment()
            .subtract(dateData, "days")
            .format("YYYY-MM-DD");
          return data;
        } else if (typeof dateData === "object") {
          return dateData;
        }
        return data;
      }
    },
    async fetchOrderStatusChart() {
      if (this.$currentUserData.category === "TA") {
        const payload = {
          items: [
            {
              key: "orderbystatus-graph",
              variables: {
                ...this.getDateData(this.selectedDate.value),
                ...this.getStatusData(
                  this.selectedStatusOptions.map((x) => x.value)
                ),
                tenant: this.userId,
              },
            },
          ],
        };
        await this.$store.dispatch("partner/fetchBulkChart", payload);
      } else if (this.$currentUserData.category === "SELLER") {
        const payload = {
          items: [
            {
              key: "seller-orderbystatus-graph",
              variables: {
                ...this.getDateData(this.selectedDate.value),
                ...this.getStatusData(
                  this.selectedStatusOptions.map((x) => x.value)
                ),
                tenant: this.$currentUserData.tenant,
                userId: this.userId,
              },
            },
          ],
        };
        await this.$store.dispatch("partner/fetchBulkChart", payload);
      } else if (
        this.$currentUserData.category === "DISTRIBUTOR" ||
        this.$currentUserData.category === "DEALER" ||
        this.$currentUserData.category === "SUB_DEALER"
      ) {
        const payload = {
          items: [
            {
              key: "subdealer-orderbystatus-graph",
              variables: {
                ...this.getDateData(this.selectedDate.value),
                ...this.getStatusData(
                  this.selectedStatusOptions.map((x) => x.value)
                ),
                tenant: this.$currentUserData.tenant,
                userId: this.userId,
              },
            },
          ],
        };
        await this.$store.dispatch("partner/fetchBulkChart", payload);
      }
    },

    findButtonClick1() {
      let e = {
        fromDate: this.startDate1,
        toDate: this.endDate1,
      };
      this.$refs["date-range1"].hide();
      this.fetchOrderValueChart();
    },
    changeDate1(e) {
      this.selectedDate1 = e;
      if (e.value == "custom") {
        this.$refs["date-range1"].show();
        return;
      }
      this.fetchOrderValueChart();
    },
    getDateData1(dateData) {
      if (dateData == "custom") {
        const data = {
          fromDate: this.startDate1,
          toDate: this.endDate1,
        };
        return data;
      }
      if (dateData == 1) {
        const data = {
          fromDate: moment().format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        };
        return data;
      } else {
        const data = {
          fromDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        };
        if (typeof dateData === "number") {
          data.fromDate = moment()
            .subtract(dateData, "days")
            .format("YYYY-MM-DD");
          return data;
        } else if (typeof dateData === "object") {
          return dateData;
        }
        return data;
      }
    },
    changeStatus(e) {
      this.selectedStatusOptions = e;
      this.fetchOrderStatusChart();
    },
    getStatusData(statusData) {
      let data = {};
      statusData.forEach((statusValue) => {
        if (statusValue === "Processing") {
          data["status1"] = statusValue;
        } else if (statusValue === "Delivered") {
          data["status2"] = statusValue;
        } else if (statusValue === "Created") {
          data["status3"] = statusValue;
        } else if (statusValue === "Out For Delivery") {
          data["status4"] = statusValue;
        } else if (statusValue === "Payment Failed") {
          data["status5"] = statusValue;
        } else if (statusValue === "Cancelled") {
          data["status6"] = statusValue;
        } else if (statusValue === "Rejected") {
          data["status7"] = statusValue;
        } else if (statusValue === "Returned") {
          data["status8"] = statusValue;
        } else if (statusValue === "Dispatched") {
          data["status9"] = statusValue;
        } else if (statusValue === "Refund") {
          data["status10"] = statusValue;
        } else if (statusValue === "Delivery Attached") {
          data["status11"] = statusValue;
        }
      });
      return data;
    },
    changeStatus1(e) {
      this.selectedStatusOptions1 = e;
      this.fetchOrderValueChart();
    },
    getStatusData1(statusData) {
      let data = {};
      statusData.forEach((statusValue) => {
        if (statusValue === "Processing") {
          data["status1"] = statusValue;
        } else if (statusValue === "Delivered") {
          data["status2"] = statusValue;
        } else if (statusValue === "Created") {
          data["status3"] = statusValue;
        } else if (statusValue === "Out For Delivery") {
          data["status4"] = statusValue;
        } else if (statusValue === "Payment Failed") {
          data["status5"] = statusValue;
        } else if (statusValue === "Cancelled") {
          data["status6"] = statusValue;
        } else if (statusValue === "Rejected") {
          data["status7"] = statusValue;
        } else if (statusValue === "Returned") {
          data["status8"] = statusValue;
        } else if (statusValue === "Dispatched") {
          data["status9"] = statusValue;
        } else if (statusValue === "Refund") {
          data["status10"] = statusValue;
        } else if (statusValue === "Delivery Attached") {
          data["status11"] = statusValue;
        }
      });
      return data;
    },

    findButtonClick3() {
      let e = {
        fromDate: this.startDate3,
        toDate: this.endDate3,
      };
      this.$refs["date-range3"].hide();
      this.fetchOrderByTypeChart();
    },
    changeDate3(e) {
      this.selectedDate3 = e;
      if (e.value == "custom") {
        this.$refs["date-range3"].show();
        return;
      }
      this.fetchOrderByTypeChart();
    },
    getDateData3(dateData) {
      if (dateData == "custom") {
        const data = {
          fromDate: this.startDate3,
          toDate: this.endDate3,
        };
        return data;
      }
      if (dateData == 1) {
        const data = {
          fromDate: moment().format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        };
        return data;
      } else {
        const data = {
          fromDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        };
        if (typeof dateData === "number") {
          data.fromDate = moment()
            .subtract(dateData, "days")
            .format("YYYY-MM-DD");
          return data;
        } else if (typeof dateData === "object") {
          return dateData;
        }
        return data;
      }
    },
    async fetchOrderByTypeChart() {
      if (this.$currentUserData.category === "TA") {
        const payload = {
          items: [
            {
              key: "orderbytype-pos-graph",
              variables: {
                ...this.getDateData3(this.selectedDate3.value),
                tenant: this.userId,
              },
            },
            {
              key: "orderbytype-online-graph",
              variables: {
                ...this.getDateData3(this.selectedDate3.value),
                tenant: this.userId,
              },
            },
          ],
        };
        await this.$store.dispatch(
          "partner/fetchOrderByTypeChartReport",
          payload
        );
      } else if (this.$currentUserData.category === "SELLER") {
        const payload = {
          items: [
            {
              key: "seller-orderbytype-pos-graph",
              variables: {
                ...this.getDateData3(this.selectedDate3.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "seller-orderbytype-online-graph",
              variables: {
                ...this.getDateData3(this.selectedDate3.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
          ],
        };
        await this.$store.dispatch(
          "partner/fetchOrderByTypeChartReport",
          payload
        );
      } else if (
        this.$currentUserData.category === "DISTRIBUTOR" ||
        this.$currentUserData.category === "DEALER" ||
        this.$currentUserData.category === "SUB_DEALER"
      ) {
        const payload = {
          items: [
            {
              key: "subdealer-orderbytype-pos-graph",
              variables: {
                ...this.getDateData3(this.selectedDate3.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
            {
              key: "subdealer-orderbytype-online-graph",
              variables: {
                ...this.getDateData3(this.selectedDate3.value),
                userId: this.userId,
                tenant: this.$currentUserData.tenant,
              },
            },
          ],
        };
        await this.$store.dispatch(
          "partner/fetchOrderByTypeChartReport",
          payload
        );
      }
    },

    async fetchOrderValueChart() {
      if (this.$currentUserData.category === "TA") {
        const payload = {
          items: [
            {
              key: "orderbyvalue-graph",
              variables: {
                ...this.getDateData1(this.selectedDate1.value),
                ...this.getStatusData1(
                  this.selectedStatusOptions1.map((x) => x.value)
                ),
                tenant: this.userId,
              },
            },
          ],
        };
        await this.$store.dispatch("partner/fetchChart", payload);
      } else if (this.$currentUserData.category === "SELLER") {
        const payload = {
          items: [
            {
              key: "seller-orderbyvalue-graph",
              variables: {
                ...this.getDateData1(this.selectedDate1.value),
                ...this.getStatusData1(
                  this.selectedStatusOptions1.map((x) => x.value)
                ),
                tenant: this.$currentUserData.tenant,
                userId: this.userId,
              },
            },
          ],
        };
        await this.$store.dispatch("partner/fetchChart", payload);
      } else if (
        this.$currentUserData.category === "DISTRIBUTOR" ||
        this.$currentUserData.category === "DEALER" ||
        this.$currentUserData.category === "SUB_DEALER"
      ) {
        const payload = {
          items: [
            {
              key: "subdealer-orderbyvalue-graph",
              variables: {
                ...this.getDateData1(this.selectedDate1.value),
                ...this.getStatusData1(
                  this.selectedStatusOptions1.map((x) => x.value)
                ),
                tenant: this.$currentUserData.tenant,
                userId: this.userId,
              },
            },
          ],
        };
        await this.$store.dispatch("partner/fetchChart", payload);
      }
    },
    createRequest() {
      const payload = {
        filterBy: {
          ...this.getDateData(this.selectedDate.value),
          collectionName: "ORDER",
        },
        requestBy: {
          _id: this.$currentUserData._id,
          name: this.$currentUserData.userName,
          email: this.$currentUserData.email,
          phone: this.$currentUserData.phone,
        },
      };
      this.$store
        .dispatch("bulkNotification/createRequestDownload", payload)
        .then(() => {
          this.$swal({
            title: "Success",
            text: "Request successful!!",
            type: "success",
          });
        })
        .catch((error) =>
          this.$toasted.error(
            error.message ? error.message : "Error Request could not completed"
          )
        );
      this.fetchRequest();
    },
  },

  mounted() {
    this.dashboardReport();
    this.fetchOrderStatusChart();
    this.fetchOrderValueChart();
    this.fetchOrderByTypeChart();
  },
};
</script>

<style scoped>
.total-order-header .card-header {
  background: #2c7df7;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.orderbySale-header .card-header {
  background: #3163c3;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.orderbyStatus-header .card-header {
  background: #6ebaff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.card.total-order-header {
  height: 270px;
}
.total-order-header {
  margin-bottom: 25px !important;
}
.card.orderbySale-header {
  height: 270px;
}
.card.orderbyStatus-header {
  height: 270px;
}
.green-chart-icon i {
  background: #def6ee;
  text-align: center;
  color: #65d27d;
  border-radius: 5px;
  font-size: 16px !important;
  height: 36px;
  width: 36px;
  line-height: 36px;
}

.red-chart-icon i {
  background: #f6dede;
  text-align: center;
  color: #fd8181;
  border-radius: 5px;
  font-size: 16px !important;
  height: 36px;
  width: 36px;
  line-height: 36px;
}

.order-price-heading {
  line-break: anywhere;
  line-height: 24px;
}

.chart-doughnut {
  height: 400px;
  width: 400px;
  margin-left: -5%;
}
.upload-btn {
  height: 39px;
}
</style>
